module.exports = __webpack_public_path__ + "img/120-005927.png";